import { cloudCall } from "../../../shared/api";
import { localKv } from "./kv";

export const IMP_KEY = "hermes.impersonation";
export const SESSION_KEY = "hermes.session";

export type ImpersonationMeta = {
  impersonationId: string;
  adminToken: string;
  adminEmail: string;
  testMode: boolean;
  targetEmail: string;
};

export type SessionUser = { id: string; email: string; name: string; token: string };

export function readImpersonation(): ImpersonationMeta | null {
  try {
    const raw = sessionStorage.getItem(IMP_KEY);
    return raw ? (JSON.parse(raw) as ImpersonationMeta) : null;
  } catch {
    return null;
  }
}

export function clearImpersonation() {
  sessionStorage.removeItem(IMP_KEY);
}

export async function endImpersonation(saveChanges: boolean): Promise<SessionUser | null> {
  const meta = readImpersonation();
  if (!meta) return null;
  const data = await cloudCall<{
    session_token?: string;
    user?: { id: string; email: string; name?: string };
  }>("/admin/impersonate/end", {
    method: "POST",
    token: meta.adminToken,
    body: JSON.stringify({
      impersonation_id: meta.impersonationId,
      save_changes: saveChanges,
    }),
  });
  if (!data.session_token || !data.user) {
    throw new Error("No se pudo restaurar la sesión de administrador");
  }
  const admin: SessionUser = {
    id: data.user.id,
    email: data.user.email,
    name: data.user.name || data.user.email,
    token: data.session_token,
  };
  await localKv.set(SESSION_KEY, JSON.stringify(admin));
  clearImpersonation();
  return admin;
}

export async function askDisconnectFlow(): Promise<"save" | "discard" | "cancel" | "live"> {
  const meta = readImpersonation();
  if (!meta) return "cancel";
  if (!meta.testMode) {
    const ok = window.confirm("¿Desconectar y volver a tu cuenta de administrador?");
    return ok ? "live" : "cancel";
  }
  const save = window.confirm(
    "¿Guardar los cambios realizados en la cuenta del usuario?\n\nAceptar = guardar\nCancelar = preguntar si descartar",
  );
  if (save) return "save";
  const discard = window.confirm(
    "¿Descartar los cambios y restaurar los datos anteriores del usuario?\n\nAceptar = descartar\nCancelar = seguir conectado",
  );
  return discard ? "discard" : "cancel";
}
